var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.storeUser)?_c('v-main',[_c('SideNav'),_c('TopNav'),(_vm.$store.state.showContent)?_c('RouterViewWithError'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }